import {
  faCartShopping,
  faListCheck,
  faQuestion,
  faSquarePollHorizontal,
  faUserCheck,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useMemo } from "react";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  FormControl,
  Dropdown,
} from "react-bootstrap";
import axios from "axios";
import { API_URL, NEW_API_URL } from "../../../constants/Globals";
import useDebounce from "../../../hooks/useDebounce";
import {
  addBranchToStep,
  addStepToSequence,
  getSequenceById,
} from "../../../services/CollectionsSvc";
import { faBullseyePointer } from "@fortawesome/pro-light-svg-icons";
import StartDebate from "./StartDebate";
import NewFormModal from "./NewFormModal";
import AddEditCallToActionModal from "../content/AddEditCallToActionModal";
import AddEditSignUpModal from "../content/AddEditSignUpModal";
import AddEditProductModal from "../content/AddEditProductModal";
// import AddEditSignUpModal from "../content/AddEditSignUpModal";
let TYPES = [
  { type: "Poll", icon: faSquarePollHorizontal },
  // { type: "Question", icon: faQuestion },
  { type: "Form", icon: faListCheck },
  { type: "CTA", icon: faBullseyePointer },
  { type: "Product", icon: faCartShopping },
  { type: "Sign-Up", icon: faUserCheck }
];
const BuildSequence = ({
  show,
  onClose,
  onNext,
  selNetworkId,
  sequenceId,
  orderNumber,
  selectedStep,
  sequenceDetails,
  sequenceType,
  isFromAddBranch,
  networks,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [pollList, setPollList] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const debouncedSearch = useDebounce(searchQuery, 1000);
  const [showBuildModal, setShowBuildModal] = useState(show);
  const [selectedType, setSelectedType] = useState(null);
  const [showStartDebate, setShowStartDebate] = useState(false);
  const [showNewFormModal, setShowNewFormModal] = useState(false);
  const [showNewCTAModal, setShowNewCTAModal] = useState(false);
  const [showNewProductModal, setShowNewProductModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [signUpModalData, setSignUpModalData] = useState({});
  const [formData, setFormData] = useState({ optionValue: "" });
  const { part: { debate = {} } = {} } = selectedStep || {};
  const [CTAList, setCTAList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [signupFormList, setSignupFormList] = useState(false);
  const [sequenceData, setSequenceData] = useState({});
  const disablePollTypeForQuiz = useMemo(() => {
    return sequenceData?.id && sequenceData?.type === "Quiz";
  }, [sequenceData]);
  const [aiPrompt, setAiPrompt] = useState("");
  const [isGeneratingWithAI, setIsGeneratingWithAI] = useState(false);

  const disableQuestionTypeForSurvey = useMemo(() => {
    return sequenceData?.id && sequenceData?.type === "Survey";
  }, [sequenceData]);

  const isBranchMode = !!selectedStep;
  const disableOtherFields = isBranchMode && !formData.optionValue;

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setShowDropdown(true);
  };

  useEffect(() => {
    if (!sequenceDetails?.id && sequenceId) {
      fetchSequence();
      return;
    } else if (sequenceDetails?.id) {
      setSequenceData(sequenceDetails);
    }
  }, [sequenceDetails, sequenceId]);

  const fetchSequence = async () => {
    const response = await getSequenceById(sequenceId);
    if (response.data.data) {
      const sequence = response.data.data;
      setSequenceData(sequence);
    }
  };

  const fetchPolls = () => {
    axios
      .get(
        `${API_URL}/admin/debate/getDebates?isActive=1&perPage=5&pageNumber=1&clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&isQuestion=0`
      )
      .then(({ data }) => setPollList(data.data.rows));
  };

  const fetchQuestions = () => {
    axios
      .get(
        `${API_URL}/admin/debate/getDebates?isActive=1&perPage=5&pageNumber=1&clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&isQuestion=1`
      )
      .then(({ data }) => setQuestionList(data.data.rows));
  };

  const fetchForms = () => {
    axios
      .get(
        `${API_URL}/forms/search?clientId=${selNetworkId}&name=${debouncedSearch.trim()}&pageSize=5&pageNumber=1`
      )
      .then(({ data }) => {
        setFormList(data.data.forms);
      });
  };

  const fetchCTA = () => {
    axios
      .get(
        `${NEW_API_URL}/call-to-action?clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&pageNumber=1&perPage=5`
      )
      .then(({ data }) => {
        setCTAList(data.data.rows);
      });
  };

  const fetchProducts = () => {
    axios
      .get(
        `${NEW_API_URL}/product?clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&pageNumber=1&perPage=5`
      )
      .then(({ data }) => {
        setProductList(data.data.rows);
      });
  };

  const fetchSignUpForms = () => {
    axios
      .get(
        `${NEW_API_URL}/signup-form?clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&pageNumber=1&perPage=5`
      )
      .then(({ data }) => {
        setSignupFormList(data.data.rows);
      });
  };

  const handleGenerateWithAI = async () => {
    if (!aiPrompt.trim()) return;

    try {
      setIsGeneratingWithAI(true);

      const payload = {
        customInstructions: aiPrompt,
        goal: "lead gen",
        targetAudience: "",
        additionalContext: "",
        sequenceId: sequenceId,
        clientId: selNetworkId,
      };

      const { data } = await axios.post(`${NEW_API_URL}/sequences/ai-sequence-gennerator`, payload);

      if (data.data?.sequenceId) {
        onClose(true);
        if (onNext) {
          onNext("next");
        }
      }
    } catch (error) {
      console.error("AI sequence generation failed", error);
      alert("Failed to generate sequence with AI");
    } finally {
      setIsGeneratingWithAI(false);
    }
  };

  useEffect(() => {
    if (debouncedSearch) {
      if (!disableQuestionTypeForSurvey) {
        fetchQuestions();
      }
      fetchForms();
      fetchCTA();
      fetchProducts();
      fetchSignUpForms();
      if (!disablePollTypeForQuiz) {
        fetchPolls();
      }
    }
  }, [debouncedSearch, disablePollTypeForQuiz, disableQuestionTypeForSurvey]);

  useEffect(() => {
    setShowBuildModal(show);
  }, [show]);

  useEffect(() => {
    if (sequenceType == "Quiz") {
      const index = TYPES.findIndex(item => item.type === "Question");
      if (index == -1) { // only add when question type is not already present
        TYPES.push({ type: "Question", icon: faQuestion });
      }
    } else {
      // TYPES = TYPES.filter(item => item.type !== "Question"); change
      const index = TYPES.findIndex(item => item.type === "Question");
      if (index !== -1) { // only remove when question type is already present
        TYPES.splice(index, 1);
      }
    }
  }, [sequenceType]);

  useEffect(() => {
    if (selectedItem) {
      handleNext();
    }
  }, [selectedItem]);

  const handleDropdownSelect = (item) => {
    setSelectedItem(item);
    setSearchQuery(item.thesis || item.name || item.title);
    setShowDropdown(false);
  };

  const handleIconClick = (type) => {
    setSelectedType(type);
  };

  const handleNext = async () => {
    if (!selectedType && !selectedItem) {
      alert("Please select an item to add to the sequence.");
      return;
    }
    // console.log('Handle next clicked....', selectedItem, isFromAddBranch, selectedStep);
    if (selectedItem) {
      const payload = {
        sequenceId: sequenceId || null,
        order: orderNumber + 1,
        isBranch: false,
        partType: selectedItem.type,
        partId: selectedItem.id,
        content: selectedItem.thesis || selectedItem.name,
      };

      if (selectedStep) {
        try {
          const findExistingBranch = selectedStep?.branches?.find(
            (branch) => String(branch.sideId) === String(formData.optionValue) || branch.branchOption === formData.optionValue
          );
          if (findExistingBranch) {
            onClose(true);
            alert("Branch already exists for the selected poll's option");
            return;
          }
          const response = await addStepToSequence(payload);
          const nextId = response.data.data;

          if (nextId) {
            let branchOption;
            if (debate?.isQuestion) {
              branchOption = formData.optionValue;
            } else {
              const findSelectedBranch = debate.sides.find(
                (side) => String(side.id) === String(formData.optionValue)
              );
              branchOption = findSelectedBranch ? findSelectedBranch.text : "";
            }
            const data = {
              branchOption,
              nextStepId: nextId,
            };
            await addBranchToStep(selectedStep.id, data);
            onClose(true);
          }
        } catch (error) {}
      } else {
        await addStepToSequence(payload);
        onClose(true);
      }

      if (onNext) {
        onNext("next");
      }
      return;
    }

    if (selectedType === "Poll" || selectedType === "Question") {
      setShowStartDebate(true);
      setShowBuildModal(false);
    } else if (selectedType === "Form") {
      setShowNewFormModal(true);
      setShowBuildModal(false);
    } else if (selectedType === "CTA") {
      setShowNewCTAModal(true);
      setShowBuildModal(false);
    } else if (selectedType === "Product") {
      setShowNewProductModal(true);
      setShowBuildModal(false);
    } else if (selectedType === "Sign-Up") {
      setShowBuildModal(false);
      setSignUpModalData({ sequenceId, orderNumber, selNetworkId, isFromAddBranch, selectedStepId: selectedStep?.id });
      setShowSignUpModal(true);
    } else {
      alert("This type is not supported yet.");
    }
  };

  const createBranch = async (nextId) => {
    try {
      const findExistingBranch = selectedStep?.branches?.find(
        (branch) => String(branch.sideId) === String(formData.optionValue) || branch.branchOption === formData.optionValue
      );
      if (findExistingBranch) {
        onClose(true);
        alert("Branch already exists for the selected poll's option");
        return;
      }
      if (nextId) {
        let branchOption;
        if (debate?.isQuestion) {
          branchOption = formData.optionValue;
        } else {
          const findSelectedBranch = debate.sides.find(
            (side) => String(side.id) === String(formData.optionValue)
          );
          branchOption = findSelectedBranch ? findSelectedBranch.text : "";
        }
        const data = {
          branchOption,
          nextStepId: nextId,
        };
        await addBranchToStep(selectedStep.id, data);
        onClose(true);
      }
    } catch (error) {}
  };

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Modal
        show={showBuildModal}
        onHide={onClose}
        centered
        dialogClassName="custom-modal-width"
        size="xl"
        keyboard={false}
      >
        <Modal.Header closeButton className="custom-modal-header">
          <Modal.Title>
            {selectedStep ? "Add Branch to Step" : "Build your Sequence"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          {orderNumber === 0 && (
            <div className="mb-4 border-bottom pb-4">
              <Form.Group className="mb-4">
                <Form.Label className="standard-dropdown-label">
                  Create your {sequenceType === "Quiz" ? "Quiz" : "Survey"} with AI
                </Form.Label>
                <InputGroup>
                  <FormControl
                    as="textarea"
                    rows={1}
                    placeholder="Describe your sequence including any goals, KPIs, and specific instruction"
                    value={aiPrompt}
                    onChange={(e) => setAiPrompt(e.target.value)}
                    disabled={isGeneratingWithAI}
                  />

                  <Button
                    variant="primary"
                    disabled={!aiPrompt.trim() || isGeneratingWithAI}
                    onClick={handleGenerateWithAI}
                    style={{ minWidth: "60px" }}
                  >
                    {isGeneratingWithAI ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      <FontAwesomeIcon icon={faArrowRight} />
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>
            </div>
          )}

          {/* <hr className="mb-4" /> */}

          <Form>
            {selectedStep && (
              <Form.Group className="mb-4">
                <Form.Label className="standard-dropdown-label">
                  Select an option
                </Form.Label>
                <Form.Select
                  value={formData.optionValue}
                  name="optionValue"
                  onChange={handleOnChange}
                  aria-label="Select an option"
                >
                  <option value="" disabled>
                    Select an option
                  </option>
                  {debate?.isQuestion ? (
                    <>
                      <option value="correct">Correct</option>
                      <option value="incorrect">Incorrect</option>
                    </>
                  ) : (
                    debate?.sides?.length > 0 &&
                    debate.sides.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.text}
                      </option>
                    ))
                  )}
                </Form.Select>
              </Form.Group>
            )}
            <Form.Group className="mb-4">
              <Form.Label className="standard-dropdown-label">
                Select an existing{" "}
                {disablePollTypeForQuiz ? "question or form" : "poll or form"}
              </Form.Label>
              <InputGroup>
                <FormControl
                  type="text"
                  placeholder={`Search for a ${disablePollTypeForQuiz ? "question or form" : "poll or form"}`}
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onFocus={() => setShowDropdown(true)}
                  disabled={disableOtherFields}
                />
              </InputGroup>
              {showDropdown && searchQuery && (
                <Dropdown.Menu
                  show
                  style={{
                    width: "75%",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {pollList.length > 0 && (
                    <>
                      <Dropdown.Header>Polls</Dropdown.Header>
                      {pollList.map((poll, index) => (
                        <Dropdown.Item
                          key={`poll-${index}`}
                          onClick={() =>
                            handleDropdownSelect({ ...poll, type: "poll" })
                          }
                        >
                          {poll.thesis}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {questionList.length > 0 && (
                    <>
                      <Dropdown.Header>Questions</Dropdown.Header>
                      {questionList.map((question, index) => (
                        <Dropdown.Item
                          key={`question-${index}`}
                          onClick={() =>
                            handleDropdownSelect({
                              ...question,
                              type: "question",
                            })
                          }
                        >
                          {question.thesis}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {formList.length > 0 && (
                    <>
                      <Dropdown.Header>Forms</Dropdown.Header>
                      {formList.map((form, index) => (
                        <Dropdown.Item
                          key={`form-${index}`}
                          onClick={() =>
                            handleDropdownSelect({ ...form, type: "form" })
                          }
                        >
                          {form.name}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {CTAList.length > 0 && (
                    <>
                      <Dropdown.Header>Call to Actions</Dropdown.Header>
                      {CTAList.map((cta, index) => (
                        <Dropdown.Item
                          key={`cta-${index}`}
                          onClick={() =>
                            handleDropdownSelect({ ...cta, type: "cta" })
                          }
                        >
                          {cta.title}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {productList.length > 0 && (
                    <>
                      <Dropdown.Header>Products</Dropdown.Header>
                      {productList.map((product, index) => (
                        <Dropdown.Item
                          key={`product-${index}`}
                          onClick={() =>
                            handleDropdownSelect({
                              ...product,
                              type: "product",
                            })
                          }
                        >
                          {product.title}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {signupFormList.length > 0 && (
                    <>
                      <Dropdown.Header>Sign-Up Forms</Dropdown.Header>
                      {signupFormList.map((signupForm, index) => (
                        <Dropdown.Item
                          key={`signupForm-${index}`}
                          onClick={() =>
                            handleDropdownSelect({
                              ...signupForm,
                              type: "sign-up",
                            })
                          }
                        >
                          {signupForm.title || signupForm.name}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}

                  {pollList.length === 0 &&
                    questionList.length === 0 &&
                    formList.length === 0 &&
                    CTAList.length === 0 &&
                    productList.length === 0 && (
                      <Dropdown.Item disabled>No options found</Dropdown.Item>
                    )}
                </Dropdown.Menu>
              )}
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="standard-dropdown-label">
                Or start from scratch
              </Form.Label>
              {selectedItem && (
                <div className="mb-3 d-flex justify-content-end">
                  <a
                    className="reset-link"
                    href="#"
                    style={{ textDecoration: "none", color: "#2F80ED" }}
                    onClick={() => {
                      setSelectedItem(null);
                      setSearchQuery("");
                      setSelectedType(null);
                      setShowDropdown(false);
                    }}
                  >
                    Reset
                  </a>
                </div>
              )}
              <div className="d-flex flex-wrap justify-content-center">
                {TYPES.map(({ type, icon }, index) => {
                  const disableTypesForSequence =
                    (disablePollTypeForQuiz && type === "Poll") ||
                    (disableQuestionTypeForSurvey && type === "Question");
                  if (disableTypesForSequence) return null;
                  return (
                    <div
                      key={index}
                      className="sequence-type-box me-4"
                      onClick={() =>
                        !selectedItem &&
                        !disableOtherFields &&
                        handleIconClick(type)
                      }
                      style={{
                        cursor:
                          selectedItem || disableOtherFields
                            ? "not-allowed"
                            : "pointer",
                        padding: "20px",
                        textAlign: "center",
                        borderRadius: "5px",
                        boxShadow: "2px 2px 2px 3px rgba(0, 0, 0, 0.1)",
                        flex: "0 0 27%",
                        marginBottom: "20px",
                        border:
                          selectedType === type &&
                          !selectedItem &&
                          !disableOtherFields
                            ? "2px solid #2F80ED"
                            : "2px solid transparent",
                        opacity: selectedItem || disableOtherFields ? 0.5 : 1,
                        pointerEvents:
                          selectedItem || disableOtherFields ? "none" : "auto",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={icon}
                        style={{
                          color: "#000000",
                          fontSize: "72px",
                          marginBottom: "10px",
                        }}
                      />
                      <div>{type}</div>
                    </div>
                  );
                })}
              </div>
            </Form.Group>
            <div className="button-container">
              <Button variant="primary" onClick={handleNext}>
                Next
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {showStartDebate && (
        <StartDebate
          show={showStartDebate}
          onClose={(nextId) => {
            setShowStartDebate(false);
            if (selectedStep) createBranch(nextId);
            onClose(true);
          }}
          selNetworkId={selNetworkId}
          sequenceId={sequenceId}
          isQuestion={selectedType === "Question"}
          orderNumber={orderNumber}
        />
      )}

      {showNewFormModal && (
        <NewFormModal
          show={showNewFormModal}
          onClose={(nextId) => {
            setShowNewFormModal(false);
            if (selectedStep) createBranch(nextId);
            onClose(true);
          }}
          sequenceId={sequenceId}
          selNetworkId={selNetworkId}
          match={{ params: { id: "new" } }}
          orderNumber={orderNumber}
        />
      )}

      {showNewCTAModal && (
        <AddEditCallToActionModal
          show={showNewCTAModal}
          onClose={(nextId) => {
            setShowNewCTAModal(false);
            if (selectedStep) createBranch(nextId);
            onClose(true);
          }}
          contentCallToActionId={0}
          sequenceId={sequenceId}
          orderNumber={orderNumber}
          match={{ params: { id: "new" } }}
          selNetworkId={selNetworkId}
        />
      )}

      {showNewProductModal && (
        <AddEditProductModal
          show={showNewProductModal}
          onClose={(nextId) => {
            setShowNewProductModal(false);
            if (selectedStep) createBranch(nextId);
            onClose(true);
          }}
          productId={0}
          sequenceId={sequenceId}
          orderNumber={orderNumber}
          match={{ params: { id: "new" } }}
          selNetworkId={selNetworkId}
        />
      )}
      {showSignUpModal && (
        <AddEditSignUpModal
          show={showSignUpModal}
          onClose={(nextId) => {
            setShowSignUpModal(false);
            if (nextId) {
              if (selectedStep) createBranch(nextId);
            }
            onClose(true);
          }}
          selNetworkId={signUpModalData.selNetworkId}
          sequenceId={signUpModalData.sequenceId}
          orderNumber={signUpModalData.orderNumber}
          isFromAddBranch={signUpModalData.isFromAddBranch}
          selectedStepId={signUpModalData.selectedStepId}
          networks={networks}
        />
      )}
    </>
  );
};

export default BuildSequence;
